import { useJsApiLoader } from "@react-google-maps/api";

const libraries: ("places" | "marker" | "drawing")[] = ["places", "marker", "drawing"];

export function useGoogleMapsLoader() {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "ruchira-google-maps",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
    libraries,
    version: "weekly",
    language: "en",
    region: "US"
  });

  return { isLoaded, loadError };
}
